import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import _ from 'lodash';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { I18N, CMap, GlobalContext, EB360MapComponent } from 'commons';
import { connect } from 'react-redux';
import * as signUpActions from 'state/actions/signUpActions';
import * as locationActions from 'state/actions/locationActions';
import * as signUpSelectors from 'state/selectors/signUpSelectors';
import { DEFAULT_MAP_CENTER } from 'constants/signUp';
import Sidebar from 'components/modals/verify-location-address/Sidebar';

const VerifyLocationModal = ({
  address: formAddress,
  geocodingAddresses: initGeocodingAddress,
  saveAddress,
  userAddressList,
  whichOnePosition,
  withinGeoFence,
  handleWhichOnePosition,
  addOrUpdateAddress,
  addOrUpdateExpLocation,
  closeLocation,
  updateLocation,
  setFieldValue,
  close,
  isWithinGeoFence,
  geocodingType,
  isUpdateLocationList,
  saveGeocodingAddress,
  ok,
  setSavedSucceed,
  isExpectedLocation,
  id
}) => {
  const {
    lang,
    googleMapParam,
    idToken,
    organization: {
      hasGeoFanceSetting,
      isEB360MapEnabled
    },
    account: { id: contactId },
  } = useContext(GlobalContext);
  const hasLat = _.findIndex(userAddressList, (o) => o.lat);
  let newPosition = {};
  let geocodingAddressesTmp = [];
  const constructGeocodingAddresses = (address, countryName) => [{
    active: true,
    addressGeoCodingSource: address.addressGeoCodingSource,
    addressName: `A - ${address.streetAddress} ${countryName}`,
    adminDistrict: address.state,
    city: address.city,
    country: countryName,
    lat: address.lat,
    lon: address.lon,
    position: { lat: address.lat, lng: address.lon },
    postalCode: address.postalCode,
    streetAddress: address.streetAddress,
    suggestionAddress: `${address.streetAddress} ${address.city} ${countryName}`,
    suite: '',
    title: 'A',
  }];

  if (saveAddress.lat && saveAddress.lon) {
    newPosition = { lat: saveAddress.lat, lng: saveAddress.lon };
    geocodingAddressesTmp = constructGeocodingAddresses(saveAddress,
      formAddress.countryName);
  } else {
    newPosition = (initGeocodingAddress.filter(address => address.active)[whichOnePosition] ||
        initGeocodingAddress[whichOnePosition] ||
        {}
    ).position;
    geocodingAddressesTmp = initGeocodingAddress;
  }

  const [geocodingAddresses, setGeocodingAddresses] = useState(geocodingAddressesTmp);
  const [shouldEditEB360Map, setShouldEditEB360Map] = useState(false);
  const [address, setAddress] = useState(formAddress);
  const [position, setPosition] = useState(newPosition);
  const [isShowFreeDragPoint, setIsShowFreeDragPoint] = useState(!geocodingAddresses.length);
  const [isWinthScope, setIsWinthScope] = useState(true);
  const [phoneModelBtnShow, setPhoneModelBtnShow] = useState(true);
  const lowerLevalRadioState = {
    isUseEnteredAddress: false,
    hideInfoWindow: false,
  };
  const addOrUpdateSuccess = () => {
    setSavedSucceed(true)
  }
  const hasGeoaddress = hasLat !== -1;
  const checkGeoSuccessCallBack = () => {
    const newAddress = {
      ...saveAddress,
      ...address,
      streetAddress: address.street,
      lat: position.lat,
      lon: position.lng,
    };
    if (isUpdateLocationList) {
      delete newAddress.countryName;
      delete newAddress.street;
      isExpectedLocation? addOrUpdateExpectedLoc(contactId, newAddress, updateLocation, id)
      : 
      addOrUpdateAddress(contactId, newAddress, updateLocation, addOrUpdateSuccess);
      closeLocation();
    } else {
      ok({ ...newAddress, position });
    }
  };

  const addOrUpdateExpectedLoc = (contactId, address, updateLocation, id) => {
    const { lat, lon } = address || {}
    address.locationSource = "Member_Portal";
    address.addressGeoCodingSource = "Manual";
    address.gisLocation = { lon: lon ?? null, lat: lat ?? null }
    delete address.id;
    addOrUpdateExpLocation(contactId, address, updateLocation, id, addOrUpdateSuccess);
  };

  const checkGeoFailCallBack = () => {
    setFieldValue('lat', '', false);
    setFieldValue('lon', '', false);
    setIsWinthScope(false);
  };
  const locationConfirmClick = () => {
    const newAddress = {
      ...saveAddress,
      ...address,
      streetAddress: address.street,
      lat: position.lat,
      lon: position.lng,
    };
    if (hasGeoFanceSetting) {
      const checkGeoParam = {
        position,
        successCallBack: checkGeoSuccessCallBack,
        failCallBack: checkGeoFailCallBack,
      };
      saveGeocodingAddress(checkGeoParam);
    } else if (isUpdateLocationList) {
      delete newAddress.countryName;
      delete newAddress.street;
      isExpectedLocation? addOrUpdateExpectedLoc(contactId, newAddress, updateLocation, id): addOrUpdateAddress(contactId, newAddress, updateLocation, addOrUpdateSuccess);
      closeLocation();
    } else {
      ok({ ...newAddress, position });
    }
  };

  useEffect(() => {
    withinGeoFence();

    return () => {
      handleWhichOnePosition(0);
    };
  }, []);

  useEffect(()=>{
      setShouldEditEB360Map(!geocodingAddresses[0].active)
  },[geocodingAddresses])
  
  const getMap = () =>{
    if (isEB360MapEnabled) {
      return (
       <EB360MapComponent
          idToken={idToken}
          lang={lang}
          coordinates={{...saveAddress, lng: saveAddress.lon}}
          address={address}
          editAddress={shouldEditEB360Map}
          onPointChange={setPosition}
          onPointAddressChange={setAddress}
        />
      )
    }
    return <CMap
                  className="map-new-height"
                  lang={lang}
                  googleMapParam={googleMapParam}
                  markers={geocodingAddresses}
                  center={position}
                  address={address}
                  setPosition={setPosition}
                  setAddress={setAddress}
                  isShowFreeDragPoint={isShowFreeDragPoint}
                  hideInfoWindow={lowerLevalRadioState.hideInfoWindow}
                  comeFrom="verify"
                  formAddress={formAddress}
                />;
  }
  return (
    <Formik
      initialValues={{
        selectedIndex: !geocodingAddresses.length ? -1 : 0,
        selectedIndexSecond: !geocodingAddresses.length ? 0 : 1,
      }}
      enableReinitialize
    >
      {({ values, setFieldValue }) => (
        <Modal
          isOpen
          modalClassName="verify-location js_listen_map new"
          aria-labelledby="verifyLocation"
        >
          <ModalHeader toggle={close} tag="h2">
            <div id="verifyLocation">
              <I18N>ssp.map.verify.your.location</I18N>
            </div>
          </ModalHeader>
          <ModalBody>
            <div className="row m-0">
              <Sidebar
                values={values}
                setFieldValue={setFieldValue}
                geocodingAddresses={geocodingAddresses}
                setGeocodingAddresses={setGeocodingAddresses}
                geocodingType={geocodingType}
                setPosition={setPosition}
                setAddress={setAddress}
                isWithinGeoFence={isWithinGeoFence}
                saveGeocodingAddressResult={isWinthScope}
                phoneModelBtnShow={phoneModelBtnShow}
                setPhoneModelBtnShow={setPhoneModelBtnShow}
                setIsShowFreeDragPoint={setIsShowFreeDragPoint}
                hasGeoaddress={hasGeoaddress}
                formAddress={formAddress}
              />
              <div
                className={
                  phoneModelBtnShow ? 'col-sm-9 location-hide pt-0 pr-0 pl-0' : 'col-sm-9 phone-mode-map pr-0 pl-0'
                }
                id="mapRegion"
              >

                {getMap()}
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button role="button" color="secondary" onClick={close}>
              <I18N>global.dialog.button.cancel</I18N>
            </Button>
            <Button
              role="button"
              color="primary"
              eb-test="ssp-mylocation-button-this-is-my-location"
              onClick={locationConfirmClick}
              onTouchStart={() => {
                window.scrollTo(0, 550);
              }}
            >
              <I18N>ssp.map.my.location</I18N>
            </Button>
            <span />
          </ModalFooter>
        </Modal>
      )}
    </Formik>
  );
};

VerifyLocationModal.defaultProps = {
  isWithinGeoFence: {},
  closeLocation: () => { },
  updateLocation: false,
  isUpdateLocationList: false,
};
VerifyLocationModal.propTypes = {
  close: PropTypes.func.isRequired,
  ok: PropTypes.func.isRequired,
  address: PropTypes.shape().isRequired,
  geocodingAddresses: PropTypes.arrayOf(PropTypes.object).isRequired,
  geocodingType: PropTypes.string.isRequired,
  withinGeoFence: PropTypes.func.isRequired,
  isWithinGeoFence: PropTypes.shape(),
  saveGeocodingAddress: PropTypes.func.isRequired,
  updateLocation: PropTypes.bool,
  addOrUpdateAddress: PropTypes.func.isRequired,
  saveAddress: PropTypes.shape().isRequired,
  closeLocation: PropTypes.func,
  isUpdateLocationList: PropTypes.bool,
  userAddressList: PropTypes.arrayOf(PropTypes.object).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  whichOnePosition: PropTypes.number.isRequired,
  handleWhichOnePosition: PropTypes.func.isRequired,
  isExpectedLocation: PropTypes.bool,
  addOrUpdateExpLocation: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  isWithinGeoFence: signUpSelectors.selectSignUpGeoInfo(state),
});

const mapDispatchToProps = dispatch => ({
  withinGeoFence: (data, callback) =>
    dispatch(signUpActions.withinGeoFence.action({ data, callback })),
  saveGeocodingAddress: address =>
    dispatch(locationActions.saveGeocodingAddress.action({ address })),
  addOrUpdateAddress: (contactId, address, update, successCallback) => dispatch(locationActions.saveOrUpdateLocations.action({ contactId, address, update, successCallback })),
  addOrUpdateExpLocation: (contactId, address, update, id, successCallback) => dispatch(locationActions.saveOrUpdateExpectedLocations.action({ contactId, address, update, id, successCallback })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VerifyLocationModal);
